module.exports = __webpack_public_path__ + "static/media/website_en.f8b1d32e.png";